export const ROOT_PATH = '/';
export const SITE_ID_PARAM_NAME = `siteId`;
export const SITE_WITH_ID_PATH = `/site/:${SITE_ID_PARAM_NAME}`;
export const GRANULAR_SLA_LANDING_PATH = `/sla`;
export const GRANULAR_SLA_MANAGEMENT_PATH = `/sla${SITE_WITH_ID_PATH}`;
export const BULK_GRANULAR_SLA_MANAGEMENT_PATH = '/bulkSLA';

// R2F Threshold configuration paths
export const R2F_THRESHOLD_CONFIG_PATH = '/r2f-threshold-config';
export const R2F_THRESHOLD_CONFIG_WITH_SITE_PATH = `/r2f-threshold-config/:${SITE_ID_PARAM_NAME}`;
export const BULK_R2F_THRESHOLD_CONFIG_PATH = '/bulk-r2f';

// CORA paths
export const CORA_PATH = '/cora';
export const CORA_WITH_NODE_PATH = '/:nodeId/cora';
